// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"2813":"317423ac01958dd3b14b","3093":"33b2b77f21490c6cfefb","3180":"97d7afcb138bc764e546"}[chunkId] + ".css";
};